import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constants } from '@hub/common/Constants';
import { eGridType } from '@hub/generated/enums';
import { GridDto, GridOptionDto, ServerPagingResult } from '@hub/generated/models';
import { GridController } from '@hub/generated/services';
import { GridMessages } from '@hub/generated/_messages';
import { NotificationService } from '@hub/services/NotificationService';

@Component({
  selector: 'app-grid-dialog',
  templateUrl: './gridDialog.component.html'
})
export class GridDialogComponent implements OnInit {
  constructor(
    public gridController: GridController,
    public notificationService: NotificationService
  ) { }

  setting: GridDto;
  isVisible: boolean = true;
  isCreate: boolean;
  emptyRows = new ServerPagingResult();

  @Output() onSave: EventEmitter<GridOptionDto> = new EventEmitter<GridOptionDto>();
  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() GridDto: GridDto;

  ngOnInit() {
    this.emptyRows.Data = [{}, {}];

    this.setting = this.GridDto;
    this.isCreate = this.setting.Option.GridType === eGridType.SytemDefault;
  }

  Save() {
    if (this.isCreate) {
      this.setting.Id = Constants.GUID_EMPTY;
      this.gridController.AddNewGrid(this.setting)
        .subscribe(data => {
          this.onSave.emit(data.Option);
          this.notificationService.success(GridMessages.GridAddedSuccess);
        });
    } else {
      this.gridController.UpdateGrid(this.setting)
        .subscribe(data => {
          this.onSave.emit(data.Option);
          this.notificationService.success(GridMessages.GridEditSuccess);
        });
    }
  }

  Close() {
    this.onClose.emit(false);
  }

  onChange(event: GridDto) {
    event.Columns = event.Columns.filter(i => i != undefined);
    this.setting = event;
  }
}
